import React, { useState } from "react";
import emailFinder from "../../../../assets/img/landing-page/EmailFinder.png";
import emailFinderIcon from "../../../../assets/img/landing-page/EmailFinderIcon.png";

import emailVerifier from "../../../../assets/img/landing-page/EmailVerifier.png";
import emailVerifierIcon from "../../../../assets/img/landing-page/EmailVerifierIcon.png";

import extension from "../../../../assets/img/landing-page/Extension.png";
import extensionIcon from "../../../../assets/img/landing-page/ExtensionIcon.png";

import enrich from "../../../../assets/img/landing-page/Enrich.png";
import enrichIcon from "../../../../assets/img/landing-page/EnrichIcon.png";

import emailFiner1 from "../../../../assets/img/landing-page/emailFinder1.png";
import emailFiner2 from "../../../../assets/img/landing-page/emailFinder2.png";
import emailFiner3 from "../../../../assets/img/landing-page/emailFinder3.png";

import emailVerifier1 from "../../../../assets/img/landing-page/emailVerifier1.png";
import emailVerifier2 from "../../../../assets/img/landing-page/emailVerifier2.png";
import emailVerifier3 from "../../../../assets/img/landing-page/emailVerfier3.png";

import "./style.css";
import NavTab from "../../../../components/navTab/navTab";
import NavComponent from "../../../../components/navComponent/navComponent";
const IdealCustomers = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const navTabsData = [
    {
      label: "Email Finder",
      icon: emailFinderIcon,
      active: true,
    },
    {
      label: "Email Verifier",
      icon: emailVerifierIcon,
    },
    {
      label: "Extension",
      icon: extensionIcon,
    },
    {
      label: "Enrich",
      icon: enrichIcon,
    },
    {
      label: "Extension",
      icon: extensionIcon,
    },
  ];

  const navData = [
    {
      img: emailFinder,
      heading: "Lost In The Inbox Abyss? Our Email Finder Shines The Light!",
      list: [
        {
          icon: emailFiner1,
          heading: "Find Emails By Domain",
          para: "Find all email addresses on any domain in a matter of minutes.Bulk domain option is handy if you want to explore",
        },
        {
          icon: emailFiner2,
          heading: "Find Emails By Company",
          para: "Use our database to find just the companies you need by industry, company size, location, name and more.",
        },
        {
          icon: emailFiner3,
          heading: "Get Emails From Names",
          para: "Know your lead’s name and company domain but not their email? We can find it for you",
        },
      ],
    },
    {
      img: emailVerifier,
      heading: "Dive In: Features That Redefine Excellence",
      list: [
        {
          icon: emailVerifier1,
          heading: "Syntax Check",
          para: "Identify and eliminate errors with a thorough syntax examination, maintaining the integrity of your contact list.",
        },
        {
          icon: emailVerifier2,
          heading: "Domain Verification",
          para: "Ensure emails are linked to valid domains, enhancing the reliability of your communication channels.",
        },
        {
          icon: emailVerifier3,
          heading: "Anti-Spam Checks",
          para: "Boost deliverability by avoiding spam traps, safeguarding your emails from being flagged as spam.",
        },
      ],
    },
    {
      img: extension,
      heading: "Dive In: Features That Redefine Excellence",
      list: [
        {
          icon: emailVerifier1,
          heading: "Syntax Check",
          para: "Identify and eliminate errors with a thorough syntax examination, maintaining the integrity of your contact list.",
        },
        {
          icon: emailVerifier2,
          heading: "Domain Verification",
          para: "Ensure emails are linked to valid domains, enhancing the reliability of your communication channels.",
        },
        {
          icon: emailVerifier3,
          heading: "Anti-Spam Checks",
          para: "Boost deliverability by avoiding spam traps, safeguarding your emails from being flagged as spam.",
        },
      ],
    },
    {
      img: enrich,
      heading: "Dive In: Features That Redefine Excellence",
      list: [
        {
          icon: emailVerifier1,
          heading: "Syntax Check",
          para: "Identify and eliminate errors with a thorough syntax examination, maintaining the integrity of your contact list.",
        },
        {
          icon: emailVerifier2,
          heading: "Domain Verification",
          para: "Ensure emails are linked to valid domains, enhancing the reliability of your communication channels.",
        },
        {
          icon: emailVerifier3,
          heading: "Anti-Spam Checks",
          para: "Boost deliverability by avoiding spam traps, safeguarding your emails from being flagged as spam.",
        },
      ],
    },
    {
      img: extension,
      heading: "Dive In: Features That Redefine Excellence",
      list: [
        {
          icon: emailVerifier1,
          heading: "Syntax Check",
          para: "Identify and eliminate errors with a thorough syntax examination, maintaining the integrity of your contact list.",
        },
        {
          icon: emailVerifier2,
          heading: "Domain Verification",
          para: "Ensure emails are linked to valid domains, enhancing the reliability of your communication channels.",
        },
        {
          icon: emailVerifier3,
          heading: "Anti-Spam Checks",
          para: "Boost deliverability by avoiding spam traps, safeguarding your emails from being flagged as spam.",
        },
      ],
    },
  ];

  return (
    <div
      className="section home-features"
      style={{ marginTop: "50px", marginBottom: "50px" }}
    >
      <div className="container">
        <div className="upper aos-item aos-inint aos-animate">
          <h2 style={{ textAlign: "center" }}>
            Reach your ideal customers when <br /> they are most likely to buy
            with
          </h2>
        </div>
        <div className="list-bar-wraper">
          <div className="list-bar">
            {navTabsData.map((item, i) => (
              <NavTab
                label={item.label}
                icon={item.icon}
                active={activeIndex === i}
                onClick={() => setActiveIndex(i)}
              />
            ))}
          </div>
        </div>
        <div className="row align-items-start" style={{ marginTop: "30px" }}>
          <NavComponent
            img={navData[activeIndex].img}
            heading={navData[activeIndex].heading}
            infoList={navData[activeIndex].list}
          />
        </div>
      </div>
    </div>
  );
};

export default IdealCustomers;
